import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginMainComponent } from './components/login-main/login-main.component';

const routes: Routes = [
  {
    path: '',
    component: LoginMainComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/login/login-routing.module.ts